import { isModernWebView } from "@/android/bridge"

export const HERO_COMPONENT_DATA = [
  {
    logo: 'wantToHire',
    title: 'Want to hire?',
    discreption: 'Submit your first job Ad post.',
    buttonClassName: 'border-[0px] hover:border-[0px] bg-secondary',
    buttonTitle: 'Post job',
    isArrowPresent: true,
    alt: 'post job logo',
    isPostJobButton: true
  },
  {
    logo: 'wantAJob',
    title: 'Want a job?',
    discreption: 'Apply to latest job openings.',
    buttonClassName:
      'bg-[#FFF1CC] border-solid border-[1px] border-[#FFBB00] hover:border-solid hover:border-[1px]',
    buttonTitle: 'Search jobs',
    isArrowPresent: false,
    alt: 'search job logo'
  }
]

export const con = {
  welcomeToLokal: 'Welcome to Lokal',
  loginOrSignup: 'Login or Signup',
  otpDiscription:
    'Enter the mobile number you wish to be contacted on. An OTP will be sent to this number',
  iAgreeToThe: 'I agree to the',
  and: 'and',
  yesApply: 'Yes,apply',
  termsAndConditions: 'Terms & Conditions',
  privacyPolicy: 'Privacy Policy',
  continue: 'Continue',
  checkYourSms: 'Check your SMS',
  weHaveSentYouAnOtpOn: 'We have sent you an OTP on',
  changeNumber: 'Change Number',
  enterFourDigitOtp: 'Enter 4 digit OTP',
  didNotRecieveTheOtp: 'Did not receive the OTP',
  otpCheckBoxDiscription: 'I would like to receive WhatsApp notifications',
  done: 'Done',
  incorrectCredentials: 'Incorrect credentials',
  resendOtp: 'Resend OTP',
  resendOtpIn: 'Resend OTP in',
  sendOtp: 'Send OTP',
  yourMobilenumber: 'Your mobile number',
  generateOtp: 'Generate OTP',
  password: 'Enter Password',
  checkYourSms: 'Check your SMS',
  weHaveSentYouAnOtpOn: 'We have sent you an OTP on',
  changeNumber: 'Change Number',
  enterFourDigitOtp: 'Enter 4 digit OTP',
  didNotRecieveTheOtp: 'Did not receive the OTP',
  otpCheckBoxDiscription: 'I would like to receive WhatsApp notifications',
  done: 'Done',
  enterOtp: 'Enter OTP',
  SmsSentTo: 'SMS sent to',
  submit: 'Submit',
  login: 'Login',
  getTheApp: 'Get the app',
  profileNotCreated: 'Profile not created',
  noApplicantsFound: 'No applicants found',
  trackYourJobApplicants: 'Track your job applicants here.',
  trackAllYourJobApplicants: 'Track all your job applicants here.',
  welcome: 'Welcome !',
  inReviewOurTeamWillContact1: 'In Review. Our team will contact in 24 hours.',
  inReviewOurTeamWillContact2:
    'Your job post is in review. Our team will reach out to you in next 24 hours.',
  toReview: 'To Review',
  contacted: 'Contacted',
  reason: 'Reason : ',
  backToAllJobs: 'Back to all jobs',
  applied: 'Applied',
  cancel: 'Cancel',
  delete: 'Delete',
  logOut: 'Log out',
  wantToDeletePost: 'Are you sure you want to delete post?',
  wantToLogOut: 'Are you sure you want to log out?',
  shareJobOrPost: 'Share job or post it as story via'
}

const CONDITION_FOR_FEE = `[${process?.env?.NEXT_PUBLIC_YES_ID}].includes(formData?.["fees_charged"]) || [${process?.env?.NEXT_PUBLIC_YES_ID}].includes(formData?.["fees_charged"]?.id)`

export const STEPS_IDS = [
  [
    { id: 'job_category', require: true },
    { id: 'job_title_id', require: true },
    { id: 'primary_job_role', require: true },
    { id: 'job_type', require: true },
    {
      id: 'constituency',
      require: true
    },
    {
      id: 'job_location_city',
      require: true
    },
    // {
    //   id: 'job_location_locality',
    //   require: false
    // },
    { id: 'preferred_location', require: true },
    {
      id: 'posting_locations',
      require: true,
      additionalCondition: `eval(conditions?.preferred_location)`
    },
    {
      id: 'openings_count',
      require: true,
      orCondition: 'Number(formData?.["openings_count"]) <= 0'
    },
    {
      id: 'salary_min',
      require: true,
      orCondition: 'Number(formData?.["salary_min"]) < 1000'
    },
    {
      id: 'salary_max',
      require: true,
      additionalCondition: "formData?.['salary_max'] < formData?.['salary_min']"
    },
    { id: 'shift_timing', require: true },
    { id: 'fees_charged', require: true },
    { id: 'fee_collected_at', require: false },
    {
      id: 'fee_reason_other',
      require: true,
      additionalCondition: `(${CONDITION_FOR_FEE}) && ${
        JSON?.parse(process.env.NEXT_PUBLIC_COMPONENT_SHOW)?.other_reason
      }`
    },
    { id: 'fees_charged', require: true },
    {
      id: 'fee_amount',
      require: true,
      additionalCondition: CONDITION_FOR_FEE,
      orCondition: 'Number(formData?.["fee_amount"]) <= 0'
    },
    {
      id: 'fee_reason',
      require: true,
      additionalCondition: `(${CONDITION_FOR_FEE})`
    },
    { id: 'other_details', require: false }
  ],
  [
    { id: 'qualification', require: true },
    { id: 'experience', require: true },
    { id: 'preferred_gender', require: true },
    { id: 'mobile_no', require: true, isMobileNumber: true },
    {
      id: 'whatsapp_no',
      require: true,
      isMobileNumber: true,
      additionalCondition:
        '[1].includes(formData?.["contact_preference"]) && ([false].includes(formData?.["is_whatsapp_number"]) || [false].includes(formData?.["is_whatsapp_number"]?.id))'
    },
    { id: 'contact_preference', require: true },
  ],
  [
    { id: 'company_name', require: false },
    { id: 'agency_name', require: false },
    { id: 'contact_preference', require: true },
    { id: 'job_company_logo', require: false },
    { id: 'advertiser_company_name', require: true },
    { id: 'company_size', require: true },
    { id: 'company_type', require: true },
    { id: 'is_consultancy_name', require: true },
    { id: 'company_email', require: false, errorTypes: ['company_email_regex', 'company_email_length', 'company_email_space', 'company_email_duplicate']},
  ],
  [{ id: 'plan', require: false }]
]

export const NON_B2B_FIELDS = {
  "fees_charged": true,
  "fee_collected_at": true,
  "fee_reason_other": true,
  "fee_amount": true,
  "fee_reason": true
}

export const STEP_WISE_KEYS_IN_POST_JOB = {
  1: [
    'job_category',
    'job_title_id',
    'job_title',
    'title',
    'primary_job_role',
    'job_type',
    'job_location_city',
    'job_location_locality',
    'job_place',
    'openings_count',
    'job_monthly_salary_min',
    'job_monthly_salary_max',
    'job_shift',
    'job_hours',
    'platform',
    'page-no',
    'job_candidate_location_preference',
    'posting_locations',
    'job_fee',
    'job_fee_amount',
    'job_fee_reason',
    'job_fee_reason_other',
    'job_fee_collection_time',
    'job_additional_details',
    'other_locality'
  ],
  2: [
    'job_category',
    'job_title_id',
    'job_title',
    'title',
    'primary_job_role',
    'job_type',
    'job_location_city',
    'job_location_locality',
    'job_place',
    'openings_count',
    'job_monthly_salary_min',
    'job_monthly_salary_max',
    'job_shift',
    'job_hours',
    'platform',
    'page-no',
    'job_candidate_location_preference',
    'posting_locations',
    'job_fee',
    'job_fee_amount',
    'job_fee_reason',
    'job_fee_reason_other',
    'job_fee_collection_time',
    'job_additional_details',
    'other_locality',
    'job_candidate_YOE',
    'job_candidate_minimum_education',
    'job_candidate_gender_preference',
    'platform',
    'mobile_no',
    'min_preferred_age',
    'max_preferred_age',
    'assets',
    'contact_preference',
    'preferred_languages',
    'job_recruiter_whatsapp_num',
    'page-no',
    'additional_skills',
    'skills',
    'resume_required',
    'course_id',
    'certificate_id',
  ],
  3: [
    'job_category',
    'job_title_id',
    'job_title',
    'title',
    'primary_job_role',
    'job_type',
    'job_location_city',
    'job_location_locality',
    'job_place',
    'openings_count',
    'job_monthly_salary_min',
    'job_monthly_salary_max',
    'job_shift',
    'job_hours',
    'platform',
    'page-no',
    'job_candidate_location_preference',
    'posting_locations',
    'job_fee',
    'job_fee_amount',
    'job_fee_reason',
    'job_fee_reason_other',
    'job_fee_collection_time',
    'job_additional_details',
    'other_locality',
    'job_candidate_YOE',
    'job_candidate_minimum_education',
    'job_candidate_gender_preference',
    'platform',
    'mobile_no',
    'min_preferred_age',
    'max_preferred_age',
    'assets',
    'contact_preference',
    'preferred_languages',
    'job_recruiter_whatsapp_num',
    'page-no',
    'additional_skills',
    'skills',
    'resume_required',
    'job_company_name',
    'job_agency_name',
    'job_company_logo',
    'platform',
    'page-no',
    'advertiser_company_name',
    'company_size',
    'company_type'
  ]
}

export const GET_POST_KEYS = {
  1: {
    job_category: 'job_category',
    job_title_id: 'job_title_id',
    job_title: 'job_title',
    title: 'title',
    primary_job_role: 'primary_job_role',
    job_type: 'job_type',
    job_location_city: 'job_location_city',
    job_location_locality: 'job_location_locality',
    constituency: 'job_place',
    openings_count: 'openings_count',
    salary_min: 'job_monthly_salary_min',
    salary_max: 'job_monthly_salary_max',
    shift_timing: 'job_shift',
    job_hours: 'job_hours',
    platform: 'platform',
    company_name: 'job_company_name',
    job_company_logo: 'job_company_logo',
    poster_role: 'poster_role',
    contact_preference: 'job_poster_contact_preference',
    agency_name: 'job_agency_name',
    mobile_no: 'mobile_no',
    whatsapp_no: 'job_recruiter_whatsapp_num',
    experience: 'job_candidate_YOE',
    qualification: 'job_candidate_minimum_education',
    preferred_gender: 'job_candidate_gender_preference',
    fees_charged: 'job_fee',
    assets: 'assets',
    min_preferred_age: 'min_preferred_age',
    max_preferred_age: 'max_preferred_age',
    preferred_languages: 'preferred_languages',
    fee_amount: 'job_fee_amount',
    fee_reason: 'job_fee_reason',
    fee_reason_other: 'job_fee_reason_other',
    fee_collected_at: 'job_fee_collection_time',
    other_details: 'job_additional_details',
    preferred_location: 'job_candidate_location_preference',
    posting_locations: 'posting_locations',
    advertiser_company_name: 'advertiser_company_name',
    company_size: 'company_size',
    company_type: 'company_type',
    is_consultancy_name: 'is_consultancy_name',
    additionalSkills:'additional_skills',
    skills:'skills',
    resume_required: 'resume_required',
    other_locality:'other_locality',
    course_id:'course_id',
    certificate_id:'certificate_id',
  },
  2: {
    job_category: 'job_category',
    job_title_id: 'job_title_id',
    job_title: 'job_title',
    title: 'title',
    primary_job_role: 'primary_job_role',
    job_type: 'job_type',
    //location: 'location',
    constituency: 'job_city',
    openings_count: 'openings_count',
    salary_min: 'salary_min',
    salary_max: 'salary_max',
    shift_timing: 'shift_timing',
    job_hours: 'job_hours',
    platform: 'platform',
    company_name: 'company_name',
    assets: 'assets',
    min_preferred_age: 'min_preferred_age',
    max_preferred_age: 'max_preferred_age',
    preferred_languages: 'preferred_languages',
    job_company_logo: 'job_company_logo',
    poster_role: 'poster_role',
    contact_preference: 'contact_preference',
    agency_name: 'agency_name',
    mobile_no: 'mobile_no',
    whatsapp_no: 'whatsapp_no',
    experience: 'experience',
    qualification: 'qualification',
    preferred_gender: 'preferred_gender',
    fees_charged: 'fees_charged',
    fee_amount: 'fee_amount',
    fee_reason: 'fee_reason',
    fee_reason_other: 'fee_reason_other',
    fee_collected_at: 'fee_collected_at',
    other_details: 'other_details',
    preferred_location: 'preferred_location',
    posting_locations: 'posting_locations',
    advertiser_company_name: 'advertiser_company_name',
    company_size: 'company_size',
    company_type: 'company_type',
    is_consultancy_name: 'is_consultancy_name',
    other_locality:'other_locality',
    course_id:'course_id',
    certificate_id:'certificate_id',
  },
  3: {
    job_category: 'job_category',
    job_title_id: 'job_title_id',
    job_title: 'job_title',
    title: 'title',
    primary_job_role: 'primary_job_role',
    job_type: 'job_type',
    job_location_city: 'job_location_city',
    job_location_locality: 'job_location_locality',
    constituency: 'job_place',
    openings_count: 'openings_count',
    salary_min: 'job_monthly_salary_min',
    salary_max: 'job_monthly_salary_max',
    shift_timing: 'job_shift',
    job_hours: 'job_hours',
    platform: 'platform',
    company_name: 'job_company_name',
    job_company_logo: 'job_company_logo',
    poster_role: 'poster_role',
    contact_preference: 'job_poster_contact_preference',
    agency_name: 'job_agency_name',
    mobile_no: 'mobile_no',
    whatsapp_no: 'job_recruiter_whatsapp_num',
    experience: 'job_candidate_YOE',
    qualification: 'job_candidate_minimum_education',
    preferred_gender: 'job_candidate_gender_preference',
    fees_charged: 'job_fee',
    assets: 'assets',
    min_preferred_age: 'min_preferred_age',
    max_preferred_age: 'max_preferred_age',
    preferred_languages: 'preferred_languages',
    fee_amount: 'job_fee_amount',
    fee_reason: 'job_fee_reason',
    fee_reason_other: 'job_fee_reason_other',
    fee_collected_at: 'job_fee_collection_time',
    other_details: 'job_additional_details',
    preferred_location: 'job_candidate_location_preference',
    posting_locations: 'posting_locations',
    advertiser_company_name: 'advertiser_company_name',
    company_size: 'company_size',
    company_type: 'company_type',
    is_consultancy_name: 'is_consultancy_name',
    additionalSkills:'additional_skills',
    skills:'skills',
    resume_required: 'resume_required',
    other_locality:'other_locality',
    course_id:'course_id',
    certificate_id:'certificate_id',
  }
}

export const SUBMIT_KEYS = {
  1: [
    'job_category',
    'job_title_id',
    'job_title',
    'title',
    'primary_job_role',
    'job_type',
    'job_location_city',
    'job_location_locality',
    'job_place',
    'openings_count',
    'job_monthly_salary_min',
    'job_monthly_salary_max',
    'job_shift',
    'job_hours',
    'platform',
    'job_company_name',
    'job_company_logo',
    'poster_role',
    'job_poster_contact_preference',
    'job_agency_name',
    'mobile_no',
    'job_recruiter_whatsapp_num',
    'job_candidate_YOE',
    'job_candidate_minimum_education',
    'job_candidate_gender_preference',
    'job_fee',
    'job_fee_amount',
    'job_fee_reason',
    'job_fee_reason_other',
    'job_fee_collection_time',
    'job_additional_details',
    'job_candidate_location_preference',
    'posting_locations',
    'advertiser_company_name',
    'company_size',
    'company_type',
    'is_consultancy_name',
    'advertiser_id',
    'job_district',
    'source',
    'additional_skills',
    'skills',
    'resume_required',
    'other_locality',
    'submission_type',
    'course_id',
    'certificate_id',
    'company_email',
  ],
  2: [
    'job_category',
    'title',
    'job_title_id',
    'job_title',
    'primary_job_role',
    'job_type',
    'location',
    'job_city',
    'openings_count',
    'salary_min',
    'salary_max',
    'shift_timing',
    'job_hours',
    'platform',
    'company_name',
    'job_company_logo',
    'poster_role',
    'contact_preference',
    'agency_name',
    'mobile_no',
    'whatsapp_no',
    'experience',
    'qualification',
    'preferred_gender',
    'fees_charged',
    'fee_amount',
    'fee_reason',
    'fee_reason_other',
    'fee_collected_at',
    'other_details',
    'preferred_location',
    'posting_locations',
    'advertiser_company_name',
    'company_size',
    'company_type',
    'is_consultancy_name',
    'advertiser_id',
    'job_district',
    'source',
    'additional_skills',
    'skills',
    'resume_required',
    'other_locality',
    'submission_type',
    'course_id',
    'certificate_id',
    'company_email',
  ]
}

export const ENTERPRISE_SUBMIT_KEYS = {
  1: [
    'job_category',
    'job_title_id',
    'job_title',
    'title',
    'primary_job_role',
    'job_type',
    'job_location_city',
    'job_location_locality',
    'job_place',
    'openings_count',
    'job_monthly_salary_min',
    'job_monthly_salary_max',
    'job_shift',
    'job_hours',
    'platform',
    'job_company_name',
    'job_company_logo',
    'poster_role',
    'job_poster_contact_preference',
    'job_agency_name',
    'mobile_no',
    'assets',
    'min_preferred_age',
    'max_preferred_age',
    'preferred_languages',
    'job_recruiter_whatsapp_num',
    'job_candidate_YOE',
    'job_candidate_minimum_education',
    'job_candidate_gender_preference',
    'job_additional_details',
    'job_candidate_location_preference',
    'posting_locations',
    'advertiser_company_name',
    'company_size',
    'company_type',
    'is_consultancy_name',
    'advertiser_id',
    'job_district',
    'source',
    'additional_skills',
    'skills',
    'resume_required',
    'other_locality',
    'submission_type',
    'course_id',
    'certificate_id',
    'company_email',
  ],
  2: [
    'job_category',
    'title',
    'job_title',
    'job_title_id',
    'primary_job_role',
    'job_type',
    'location',
    'job_city',
    'openings_count',
    'salary_min',
    'salary_max',
    'shift_timing',
    'job_hours',
    'platform',
    'company_name',
    'job_company_logo',
    'poster_role',
    'contact_preference',
    'agency_name',
    'mobile_no',
    'whatsapp_no',
    'experience',
    'qualification',
    'preferred_gender',
    'assets',
    'min_preferred_age',
    'max_preferred_age',
    'preferred_languages',
    'other_details',
    'preferred_location',
    'posting_locations',
    'advertiser_company_name',
    'company_size',
    'company_type',
    'is_consultancy_name',
    'advertiser_id',
    'job_district',
    'source',
    'additional_skills',
    'skills',
    'resume_required',
    'other_locality',
    'submission_type',
    'course_id',
    'certificate_id',
    'company_email',
  ]
}

export const stepFirstId = { 1: 'job_category', 2: 'company_name', 3: 'experience' }

export const ADVERTISER_DEFAULT_HEADER_NAMES = {
  advertiserJobReview: 'Review your job post',
  advertiserCandidateJobListingPage: 'Back to all jobs'
}

export const STEP_ids =  {
  1: 'advertiser_step1',
  2: 'advertiser_step2',
  3: 'advertiser_step3'
}

export const POST_REVIEW_SECTIONS_DATA = {
  section_1: [
    {
      title: 'Job title',
      key: 'title'
    },
    {
      title: 'Job role',
      key: 'primary_job_role',
      listKey: 'primary_job_roles'
    },
    {
      title: 'Job category',
      key: 'job_category',
      listKey: 'job_category_list'
    },
    {
      title: 'Job description',
      key: 'other_details'
    },
    {
      title: 'Number of openings',
      key: 'openings_count'
    },
    {
      title: 'Job type',
      key: 'job_type',
      listKey: 'job_type_list'
    },

    {
      title: 'Monthly income',
      key: ''
    },
    {
      title: 'Job shift',
      key: 'shift_timing',
      listKey: 'job_shift_list'
    },
    {
      title: 'Fees Charged',
      key: 'fees_yes_no',
      isFeeDetails: true
    }
  ],
  section_2: [
    {
      title: 'Minimum education',
      key: 'qualification',
      listKey: 'job_candidate_minimum_education_list'
    },
    {
      title: 'Years of experience',
      key: 'experience',
      listKey: 'job_candidate_YOE_list'
    },
    {
      title: 'Preferred gender',
      key: 'preferred_gender',
      listKey: 'job_candidate_gender_preference_list'
    },
    { title: 'Manage candidates through' }
  ],
  section_3: [
    {
      title: 'Company type',
      key: 'company_type'
    },
    { title: 'Consultuncy / Manpower firm name', key: 'advertiser_company_name' },
    { title: 'Company name to be displayed', key: 'company_name' }
  ]
}

const HOME = {
  name: 'HOME PAGE',
  pathname: '/seekerHomePage'
}

const JOBS = {
  name: 'JOBS',
  pathname: '/jobsFiltering'
}

const JOB_DETAIL = {
  name: 'JOB DETAIL',
  pathname: '/jobDetails'
}

export const SITEMAP = {
  name: 'SITEMAP',
  pathname: '/sitemap'
}

export const BREAD_CRUMBS_DATA = {
  jobsFiltering: [HOME, JOBS],
  jobDetails: [HOME, JOBS, JOB_DETAIL],
  sitemap: [HOME, SITEMAP]
}

export const PATHNAME_WITH_ASPATH = {
  '/seekerHomePage': 'jobs',
  '/jobsFiltering': 'jobs-near-me',
  '/sitemap': 'sitemap'
}

export const ALL_JOB_TYPES = {
  ACTIVE: 'Active',
  PENDING_OR_APPROVAL: 'Approval Pending',
  EXPIRED: 'Expired',
  REJECTED: 'Rejected',
  EXPIRING: 'Expiring',
  ONHOLD: 'On Hold'
}

export const GET_JOB_STATUS_COLOR_AND_BACKGROUND = {
  [ALL_JOB_TYPES?.ACTIVE]: { backgroundColor: '#E6FFE9', color: '#028A12' },
  [ALL_JOB_TYPES?.PENDING_OR_APPROVAL]: { backgroundColor: '#FFF8E5', color: '#8C630D' },
  [ALL_JOB_TYPES?.EXPIRED]: { backgroundColor: '#FDE7EB', color: '#DC2B49' },
  [ALL_JOB_TYPES?.REJECTED]: { backgroundColor: '#FDE7EB', color: '#DC2B49' },
  [ALL_JOB_TYPES?.EXPIRING]: { backgroundColor: '#FDE7EB', color: '#DC2B49' }
}

export const GET_JOB_STATUS = {
  1: ALL_JOB_TYPES?.PENDING_OR_APPROVAL,
  2: ALL_JOB_TYPES?.PENDING_OR_APPROVAL,
  3: ALL_JOB_TYPES?.ACTIVE,
  8: ALL_JOB_TYPES?.EXPIRED,
  '-4': ALL_JOB_TYPES?.EXPIRED,
  '-3': ALL_JOB_TYPES?.REJECTED,
  7: ALL_JOB_TYPES?.REJECTED,
  5: ALL_JOB_TYPES?.PENDING_OR_APPROVAL,
  6: ALL_JOB_TYPES?.ONHOLD
}

export const NEW_ALL_JOB_STATUS = {
  DEFAULT: 0,
  SUBMITTED: 1,
  SUBMITFAIL: -1,
  INREVIEW: 2,
  APPROVED: 3,
  DUPLICATE: -2,
  NOTAPPROVED: -3,
  UNPUBLISHED: -4,
  EXPIRED: 8,
  RE_SUBMITTED: 5
}

export const GET_BUTTON_ICON = {
  [ALL_JOB_TYPES?.ACTIVE]: '',
  [ALL_JOB_TYPES?.EXPIRED]: 'circularDoubleArrow'
}

const SUBMITTED_ON_FIELD = 'submitted_on'
const CLASSIFIED_CREATED_ON_FIELD = 'classified_created_on'

export const GET_FIELD_BASED_ON_STATUS = {
  1: SUBMITTED_ON_FIELD,
  2: SUBMITTED_ON_FIELD,
  '-3': SUBMITTED_ON_FIELD,
  7 : SUBMITTED_ON_FIELD,
  '-4': CLASSIFIED_CREATED_ON_FIELD,
  3: CLASSIFIED_CREATED_ON_FIELD,
  8: CLASSIFIED_CREATED_ON_FIELD,
  5: SUBMITTED_ON_FIELD,
  6: CLASSIFIED_CREATED_ON_FIELD
}

export const GET_TITLE_FOR_EMPTY_JOB = (no = 0) => {
  if (no === 0) return 'No active jobs found'
  return 'No jobs found'
}

export const CAPTION_BASED_ON_JOBS_STATE_INDEX = {
  0: 'Track your active jobs here. It usually takes 24 hours for job to be active',
  1: 'Track your approval pending jobs here. It usually takes 24 hours for job to be active',
  3: 'Track your expired/rejected jobs here.'
}
export const GET_CANDIDATE_STATUS_COLOR_AND_BACKGROUND = {
  'Medium Match': { backgroundColor: '#E7F3FE', color: '#0174D3' },
  'High Match': { backgroundColor: '#E6FFE9', color: '#028A12' },
  'Low Match': { backgroundColor: '#FFF8E5', color: '#8C630D' }
}

export const ADVERTISER_DASHBOARD_HEADER_DATA = [
  {
    isHamburgerPresent: true,
    isLogoClickable: false,
    isPostAJobButtonPresent: true,
    imageClass: { height: '20px', width: '100px' },
    outerClass: 'px-[16px] h-[50px]',
    loginPostJobClass: 'space-x-[12px]',
    isBackButtonPresent: isModernWebView()
  },
  {
    isHamburgerPresent: false,
    isLogoClickable: false,
    isPostAJobButtonPresent: true,
    imageClass: { height: '30.91px', width: '160px' },
    loginPostJobClass: 'space-x-[24px]',
    postAJobButtonClass: 'w-[130px] h-[38px] ',
    isProfileButtonPresent: true,
    postAJobTextClass: ' text-[16px]  leading-[21.79px] '
  }
]

export const checkIsStringContainNumbers = (string) => {
  return /\d/.test(string)
}

export const GET_SUBMISSIONS_END_URL_ENTERPRISE = '/enterprise/submissions/'

export const GET_SUBMISSIONS_FILTER_END_URL = '/submissions/submissions/v2/filters'

export const GET_SUBMISSIONS_FILTER_END_URL_ENTERPRISE = '/enterprise/submissions/filters'

export const GET_STATE_NAME_BASED_ON_INDEX = {
  0: 'active',
  1: 'pending',
  2: 'on_hold',
  3: 'rejected',
  4: 'expired'
}

export const GET_B2B_STATE_NAME_BASED_ON_INDEX = {
  0: 'all',
  1: 'active',
  2: 'expired/deactivated'
}

export const GET_EVENT_NAME_BASED_ON_JOBS_STATE_INDEX = {
  0: 'tap_active_jobs',
  1: 'tap_approval_pending',
  2: 'tap_expired_job'
}

export const GET_EVENT_NAME_BASED_ON_ONCLICK_VIEW_APPLICANTS = {
  0: 'tap_view_applicants',
  1: 'tap_reviewed_candidates',
  2: 'tap_contacted_candidated'
}

export const GET_SHARE_SOURCE_NAME_BASED_ON_INDEX = {
  0: 'wa',
  1: 'fb',
  2: 'copy_address'
}

export const GET_EVENT_NAME_BASED_ON_CANDIDATES_STATE_INDEX = {
  0: 'tap_all_candidates',
  1: 'tap_pending_review',
  2: 'tap_contacted_Applicants'
}

export const GET_EVENT_NAME_BASED_ON_CANDIDATES_STATE_INDEX_MOBILE = {
  0: 'tap_all_candidates',
  1: 'tap_recommended_candidates',
  2: 'tap_applied_candidates',
  3: 'tap_contacted_candidates'
}

export const GET_LANDING_SCREEN_PARAM_BASED_ON_TAB_INDEX = {
  0: 'all',
  1: 'pending',
  2: 'contacted'
}

export const GET_LANDING_SCREEN_PARAM_BASED_ON_TAB_INDEX_MOBILE = {
  0: 'all',
  1: 'recommended',
  2: 'applied',
  3: 'contacted'
}

export const GET_DOCUMENT_STATUS = '/advertisers/advertiser-documents/document-status/'

export const CANDIDATE_PROFILE_VIEW_SECTIONS_DATA = {
  section_1: [
    {
      title: 'Highest Qualification',
      key: 'qualification',
      listKey: 'education'
    }
  ],
  section_2: [
    {
      title: 'Experience level',
      key: 'experience',
      listKey: 'work_experience',
      // postfix: 'years'
    },
    {
      title: 'Past employer',
      key: 'past_employer',
      listKey: 'work_experience'
    },
    {
      title: 'Current designation',
      key: 'recent_designation',
      listKey: 'work_experience'
    },
    {
      title: 'Current salary',
      key: 'salary',
      listKey: 'work_experience'
    }
  ],
  section_3: [
    {
      title: 'Preferred job',
      key: 'job_category',
      listKey: 'preferences'
    },
    {
      title: 'Job Role',
      key: 'job_role',
      listKey: 'preferences'
    },
    {
      title: 'Preferred location',
      key: 'locations',
      listKey: 'preferences'
    },
    {
      title: 'Job type',
      key: 'job_type',
      listKey: 'preferences'
    },
    {
      title: 'Work time',
      key: 'work_time',
      listKey: 'preferences'
    },
    {
      title: 'Shift timings',
      key: 'shift_timing',
      listKey: 'preferences'
    }
  ]
}

export const PAYMENT_HEADLINES = [
  {text: 'Start getting applications', icon: 'greenCheck'},
  {text: 'Instant access to candidates', icon: 'greenCheck'},
  {text: 'Personalised support', icon: 'greenCheck'}
]



export const VARIANT_MAPPING = {
  "pay_now" : "old",
  "pay_later" : "new"
}

export const JOB_STATUS_LIST = [
  {
    type: 'payment_pending',
    subText3: 'Complete payment',
    extraClass: 'bg-[#FDE7EB] px-[12px] py-[12px]',
    src: 'ic_error',
    subText3Classname: "bg-[#FB0] rounded-[8px] text-greyTitleBase900 px-[16px] py-[6px]",
    eventName: 'complete_payment'
  },
  {
    type: 'payment_inprogress',
    extraClass: 'bg-[#FDE7EB]',
    src: 'ic_error'
  },
  {
    type: 'verification_inprogress',
    extraClass: 'bg-[#E7F3FE]',
    src: 'ic_schedule'
  },
  {
    type: 'payment_failed',
    subText3: 'Retry payment',
    extraClass: 'bg-[#FDE7EB] px-[12px] py-[12px]',
    src: 'ic_error',
    subText3Classname: "bg-[#FB0] rounded-[8px] text-greyTitleBase900 px-[16px] py-[6px]",
    eventName: 'retry_payment'
  },
  {
    type: 'live',
    extraClass: 'bg-[#E6FFE9]',
    src: 'ic_check_circle'
  },
  {
    type: 'rejected',
    extraClass: 'bg-[#FDE7EB]',
    src: 'ic_close1'
  },
  {
    type: 'expiring_in_days',
    extraClass: 'bg-[#FDE7EB]',
    src: 'ic_error',
    expiring: 'Job expiring in'
  },
  {
    type: 'expired',
    extraClass: 'bg-[#FDE7EB]',
    src: 'ic_error',
    expired: 'Job expired on'
  },
  {
    type: 'on_hold',
    extraClass: 'bg-[#FDE7EB]',
    src: 'ic_error'
  },
  {
    type: 'document_pending',
    subText3: 'Upload document',
    extraClass: 'bg-[#FFF8E5] px-[12px] py-[12px]',
    src: 'ic_feed',
    subText3Classname: "bg-[#FB0] rounded-[8px] text-greyTitleBase900 px-[16px] py-[6px]"
  }
]

export const REQUIRED_VERSION_FOR_PAY_LATER = 454

export const ANY_GENDER_ID = 84

export const PAYMENT_HISTORY_STATUS_CSS = {
  '2': 'text-[#028A12]',
  '-1': 'text-[#B3011D]'
}

export const PAYMENT_HISTORY_STATUS = {
  '2': 'Success',
  '-1': 'Failed'
}

export const ADVERTISER_FORM_KEYS = {
  JOB_LOCATION_CITY: 'job_location_city',
  CITY_LIST: 'city_list',
  POSTING_LOCATIONS: 'posting_locations',
  POSTING_LOCATIONS_TITLE: 'posting_locations_title',
  JOB_LOCATION_LOCALITY: 'job_location_locality',
  LOCALITY_LIST: 'locality_list'
};